import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaUserTie,
  FaBriefcase,
  FaUsers,
  FaCogs,
  FaUserShield,
  FaChevronDown,
  FaChevronUp,
  FaBars,
  FaUserCircle,
  FaBlackTie,
} from "react-icons/fa";

import "../../Styles/Sidebar.css";

function Sidebar() {
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  return (
    <div className={`admin-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* HEADER */}
      <div className="admin-sidebar-header">
        <button
          className="admin-toggle-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <FaBars />
        </button>

        <NavLink to="/dashboard" end>
          <span className="dashboard-tit">Dashboard</span>
        </NavLink>
      </div>

      <ul className="admin-sidebar-menu">
       

      <div className="line-bottom">
        <NavLink
          to="/dashboard/QuickContacts"
          className="submenu-link"
        >
          <FaUserCircle className="admin-icon" />
          <span className="admin-menu-item" style={{marginLeft:"20px"}}>Get in Touch</span>
        </NavLink>
      </div>

        {/* Permission */}
        <li>
          <div
            className="admin-menu-item"
            onClick={() => toggleMenu("permission")}
          >
            <FaUserShield className="admin-icon" />
            <span>Permission</span>
            {openMenus.permission ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`admin-submenu ${openMenus.permission ? "open" : ""}`}>
            <li>
              <NavLink to="/dashboard/Employeeapprove" className="submenu-link">
                Employee
              </NavLink>
            </li>
            <li>
              <NavLink to="/dashboard/Studentapprove" className="submenu-link">
                Student
              </NavLink>
            </li>
            <li>
              <NavLink to="/dashboard/Tpoapprove" className="submenu-link">
                TPO
              </NavLink>
            </li>
            <li>
              <NavLink to="/dashboard/Jobposting" className="submenu-link">
                Job Posting
              </NavLink>
            </li>
          </ul>
        </li>

        {/* Registration */}
        <li>
          <div
            className="admin-menu-item"
            onClick={() => toggleMenu("registration")}
          >
            <FaUserTie className="admin-icon" />
            <span>Registration</span>
            {openMenus.registration ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul
            className={`admin-submenu ${openMenus.registration ? "open" : ""}`}
          >
            <li>
              <NavLink
                to="/dashboard/ViewEmployeeRegistration"
                className="submenu-link"
              >
                Employee
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/dashboard/ViewStudentRegistration"
                className="submenu-link"
              >
                Student
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/dashboard/ViewRepresentativeRegistration"
                className="submenu-link"
              >
                Representative
              </NavLink>
            </li>
          </ul>
        </li>

        {/* Jobs */}
        <li>
          <div
            className="admin-menu-item"
            onClick={() => toggleMenu("jobs")}
          >
            <FaBriefcase className="admin-icon" />
            <span>Current Jobs</span>
            {openMenus.jobs ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`admin-submenu ${openMenus.jobs ? "open" : ""}`}>
            <li>
              <NavLink
                to="/dashboard/AdminjobList"
                className="submenu-link"
              >
                Admin Posted Jobs
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/dashboard/EmployeejobList"
                className="submenu-link"
              >
                Employee Live Jobs
              </NavLink>
            </li>
          </ul>
        </li>

        {/* Services */}
        <li>
          <div
            className="admin-menu-item"
            onClick={() => toggleMenu("services")}
          >
            <FaCogs className="admin-icon" />
            <span>Services</span>
            {openMenus.services ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`admin-submenu ${openMenus.services ? "open" : ""}`}>
            <li>
              <NavLink
                to="/dashboard/GnTotalApplications"
                className="submenu-link"
              >
                Global Networking
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/dashboard/KnTotalApplication"
                className="submenu-link"
              >
                Knowledge Sharing
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/dashboard/UstTotalApplications"
                className="submenu-link"
              >
                Ud Skill & Training
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/dashboard/JfTotalApplications"
                className="submenu-link"
              >
                Job & JobFairs
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/dashboard/Talentsection"
                className="submenu-link"
              >
                Talent Publication
              </NavLink>
            </li>
          </ul>
        </li>

        {/* Members Benefits */}
        <li>
          <div
            className="admin-menu-item"
            onClick={() => toggleMenu("benefits")}
          >
            <FaUserTie className="admin-icon" />
            <span>Members Benefits</span>
            {openMenus.benefits ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`admin-submenu ${openMenus.benefits ? "open" : ""}`}>
            <li>
              <NavLink
                to="/dashboard/Employebenefits"
                className="submenu-link"
              >
                Employee Benefits
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/dashboard/Studentbenefits"
                className="submenu-link"
              >
                Student Benefits
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/dashboard/Tpobenefits"
                className="submenu-link"
              >
                TPO Benefits
              </NavLink>
            </li>
          </ul>
        </li>
      </ul>

      {/* Board Members */}
      <div className="line-bottom">
        <NavLink
          to="/dashboard/Boardmembers"
          className="submenu-link"
        >
          <FaUsers className="admin-icon" />
          <span className="admin-menu-item">Board Members</span>
        </NavLink>
      </div>

        {/* Black Profile */}
       <div className="line-bottom">
        <NavLink
          to="/dashboard/Blockprofile"
          className="submenu-link"
        >
          <FaBlackTie className="admin-icon" />
          <span className="admin-menu-item">Black Profile</span>
        </NavLink>
      </div>

      
    </div>
  );
}

export default Sidebar;
